"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var patch_base_button_components_1 = __importDefault(require("./patch-base-button-components"));
exports.IconButton = patch_base_button_components_1.default(IconButton_1.default);
//# sourceMappingURL=icon-button.js.map